/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogSource } from '../models/LogSource';

export class ListLogSourcesResponse {
  'logSources': Array<LogSource>;
  /**
  * Cursor that points to the first record of the next page of results. Pass this value in the next request. 
  */
  'nextToken'?: string;
  /**
  * Total number of log sources that matched the filter options.
  */
  'totalCount': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "logSources",
      "baseName": "logSources",
      "type": "Array<LogSource>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListLogSourcesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

